<template>
    <div class="case_detial no-trans" v-loading="loading">
        <div class="case_detial_box">

            <div class="top_box">
                <img src="@/assets/img/login/Frame.png" alt="">
                <span class="span1" @click="handle_home">首页</span>
                > <router-link class="span2 breadcrumb_link" style="color: inherit; text-decoration: none;" to="/hot_spot">法界热点</router-link> > <span aria-current="page">详情</span>
            </div>
            <div class="detial_flex">
                <div class="inof_box" :class="{inof_box_show:is_show}">
                    <div class="info_pay_btns" v-if="is_show">
                        <div class="info_pay_btns_top"></div>
                        <div class="info_pay_btns_bom">
                            <div class="btns_pay" @click="handle_pay">
                                付费查看
                            </div>
                        </div>
                    </div>
                    <div class="info_1">
                        <div class="title_flex">
                            {{ detials.title||'' }}
                        </div>
                        <div class="tage_info">
                            <div class="tage_flex">
                                <div class="tege_title">时间：</div>
                                <div class="tege_text">{{ detials.created_at||'' }}</div>
                            </div>
                            <div class="borders"></div>
                            <div class="tage_flex">
                                <div class="tege_title"> {{ (detials.category || {}).title }}</div>
                            </div>
                        </div>
                        <div class="btns_flex">
                           
                        </div>
                        <div class="const_box">
                          
                            <div class="const_const" v-html="detials.content">
                               
                            </div>
                             <div class="pl_bq">
                                版权申明：对视频内容享有独家版权，未经许可不得以任何形式复制、转载。
                             </div>
                             <div class="pl_btns">
                                <router-link class="btns1" style="display: block; color: inherit; text-decoration: none;" :to="{ path: '/hot_spot_type_detial', query: { id: detials.previous.id } }" v-if="detials.previous && detials.previous.id">
                                    上一篇：{{ detials.previous.title }}
                                </router-link>
                                <router-link class="btns1" style="display: block; color: inherit; text-decoration: none;" :to="{ path: '/hot_spot_type_detial', query: { id: detials.next.id } }" v-if="detials.next && detials.next.id">
                                    下一篇：{{ detials.next.title }}
                                </router-link>
                             </div>
                            
                        </div>
                    </div>
                     
                </div>
                <div class="article_sidebar">
                    <hot_spot_new ref="hot_spot_new"></hot_spot_new>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'

import hot_spot_new from '@/components/law/hot_spot/hot_spo_new.vue'//右边
 


export default {
    components: {
        hot_spot_new,
    },
    name: "homes",
    data() {
        return {
            loading:false,
            is_show:false,
            detials:{
                previous:{},
                next:{},
                category:{},
            },
          
        }
    },
    computed: {
       
    },
    watch: {
        $route:{
            handler(newVal, oldVal) {
                this.get_detial()
            },
            immediate: true,
            deep: true
        },
    },
    created() {
    },
    methods: {
        handle_home(){
            this.$router.push({
                path:'/home',
            })
        },
        handle_pay(){
            this.$router.push({
                path:'/Classroom_pay',
            })
             
        },
        get_detial(){
            this.loading=true
            this.$api("getArticle", {
                id:this.$route.query.id,
			}, "get").then((res) => {
                this.loading = false
                console.log('新闻详情1',res)
                if (res.code == 1) {
                    this.detials=res.data
                } else {
                    alertErr(res.msg)
                }
            });
        },
        handle_paht(item){
            this.$router.push({
                path:'/hot_spot_type_detial',
                query:{
                    id:item.id
                },
            })
            this.get_detial()
        },
    },

}
</script>
<style scoped lang="less">
.case_detial{
    padding-bottom: 100px;
    background-color: #F5F5F5;
    .case_detial_box{
        width: 1440px;
        margin: auto;
        .top_box{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #999999;
            padding: 20px 0;

            .span1 {
                cursor: pointer;
            }

            img {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
        .detial_flex{
            display: flex;
            // align-items: center;
            justify-content: space-between;
            .inof_box{
                width: 1000px;
                .info_1{
                    // width: 1000px;
                    // height: 1429px;
                    padding: 40px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    .title_flex{
                        display: flex;
                        align-items: center;
                       
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333; 
                        img{
                            margin-left: 10px;
                            width: 70px;
                            height: 25px;
                        }

                    }
                    .tage_info{
                        display: flex;
                        align-items: center; 
                        padding-top: 16px;

                        .tage_flex{
                            display: flex;
                            align-items: center;
                            .tege_title{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                            }
                            .tege_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                span{
                                    color: #377CFD;
                                }
                            }
                        }
                        .borders{
                            width: 0;
                            height: 15px;
                            border-left: 1px solid #999999;
                            margin: 0 20px;
                        }
                    }

                    .btns_flex{
                        display: flex;
                        align-items: center;
                        padding-top: 20px;
                        padding-bottom: 24px;
                        border-bottom: 1px solid #D9D9D9;
                        .btns1{
                            width: 134px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                            }
                        }
                        .btns2{
                            width: 134px;
                            height: 36px;
                            background: #FFFFFF;
                            border-radius: 4px 4px 4px 4px;
                            border: 1px solid #377CFD;
                            margin-left: 16px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            img{
                                width: 14px;
                                height: 14px;
                                margin-right: 8px;
                            }
                        }
                    }
                    .const_box{
                        padding-top: 24px;
                        .const_flex{
                            display: flex;
                            align-items: center;
                            margin-bottom: 16px;
                            .const_title{
                                width: 100px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                            .const_text{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                            }
                        }
                        .const_const{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-bottom: 40px;
                            word-wrap: break-word !important;
                            word-break: break-all !important; 
                            div{
                                word-wrap: break-word !important;
                                word-break: break-all !important; 
                            }
                            // border-bottom: 1px solid  #D9D9D9;
                        }
                        .pl_bq{
                            padding: 0 24px ;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            width: 920px;
                            height: 48px;
                            background: #F7F7F7;
                            border-radius: 0px 0px 0px 0px;
                            line-height: 48px;

                        }
                        .pl_btns{
                         
                            padding-top: 24px;
                            .btns1{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                cursor: pointer;
                                margin-bottom: 20px;
                            }
                        }
                        .flie_flex{
                            display: flex;
                            align-items: center;
                            padding-top: 23px;
                            .flie_img{
                                display: flex;
                                align-items: center;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;
                                cursor: pointer;
                                img{
                                    width:16px ;
                                    height: 14px;
                                    margin-right: 10px;
                                }
                            }
                            .flie_name{
                                margin-left: 60px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #333333;
                                cursor: pointer;
                            }
                        }
                    }
                }
                .case_infos{
                    width: 1000px;
                    min-height: 490px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 26px;
                    padding: 25px 32px 36px 32px;
                    .case_titles{
                     
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 24px;
                        color: #333333;
                        padding-bottom: 21px;
                    }
                    .case_texts{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        line-height: 30px;
                    }
                }
                .pl_num_box{
                    width: 100%;
                    height: 50px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    display: flex;
                    align-items: center;
                    cursor: pointer;
                    justify-content: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 16px;
                    color: #8590A6;
                    margin-top: 20px;
                    margin-bottom: 24px;
                }
                .pl_infos{
                    width: 100%;
                    padding: 40px 40px 23px 40px ;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-bottom: 25px;
                    .pl_user{
                        display: flex;
                        // align-items: center;
                        justify-content: space-between;
                        .pl_user_left{
                            display: flex;
                            align-items: center;
                            .user_img{
                                width: 64px;
                                height: 64px;
                                img{
                                    width: 64px;
                                    height: 64px;
                                    border-radius: 50%;
                                }
                            }
                            .user_info{
                                padding-left: 24px;
                                .user_name{
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: bold;
                                    font-size: 24px;
                                    color: #333333;
                                }
                                .user_time{
                                    padding-top: 11px;
                                    font-family: Microsoft YaHei, Microsoft YaHei;
                                    font-weight: 400;
                                    font-size: 14px;
                                    color: #666666;
                                }

                            }
                        }
                        
                        .pl_user_right{
                            .user_nums{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #8590A6;
                            }
                        }
                        
                    }
                    .pl_const_box{
                        .pl_titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 16px;
                            color: #333333;
                            padding-top: 24px;
                        }
                        .pl_consts{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #666666;
                            padding-top: 15px;
                        }
                    }
                    .pl_btns{
                        display: flex;
                        align-items: center;
                        padding-top: 40px;
                        .btns1{
                            padding: 8px 23px;
                            background: rgba(55, 124, 253, 0.08);
                            border-radius: 4px 4px 4px 4px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #377CFD;
                            cursor: pointer;
                            img{
                                width: 14px;
                            }
                        }
                        .btns2{
                            margin-left: 8px;
                            width: 36px;
                            height: 36px;
                            background: rgba(55, 124, 253, 0.08);
                            border-radius: 4px 4px 4px 4px;
                            cursor: pointer;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            img{
                                width: 14px;
                            }
                        }
                        .btns3{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #999999;
                            margin-left: 24px;
                            cursor: pointer;
                            img{
                                width: 13px;
                                margin-right: 4px;
                            }
                        }
                    }
                    
                }
                .comment_section{
                    // width: 1000px;
                    // height: 602px;
                    padding: 23px 30px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    .title_btns{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .titles{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 18px;
                            color: #333333;
                        }
                        .btns{
                            display: flex;
                            align-items: center;
                            .btns1{
                                padding: 8px 23px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background: #377CFD;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: bold;
                                font-size: 14px;
                                color: #377CFD;

                                img{
                                    width:14px ;
                                    height: 14px;
                                    margin-right: 8px;
                                }
                            }
                            .btns2{
                                width: 36px;
                                height: 36px;
                                background:rgba(55, 124, 253, 0.08);
                                border-radius: 4px 4px 4px 4px;
                                margin-left: 8px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                img{
                                    width:14px ;
                                    height: 14px;
                                }
                            }
                            .btns3{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #999999;
                                text-align: center;
                                margin-left: 24px;
                                cursor: pointer;
                                img{
                                    width:13px ;
                                    // height: 12px;
                                    // margin-right: 8px;
                                }

                            }
                        }
                    }
                    .comment_list{
                        padding-top: 24px;
                        .items{
                            width: 940px;
                            min-height: 220px;
                            background: #FFFFFF;
                            border-radius: 3px 3px 3px 3px;
                            border: 1px solid #D7DEE5;
                            margin-bottom: 17px;
                            padding: 21px 29px 30px 25px;
                            .items_top{
                                display: flex;
                                .user_imgs{
                                    width: 64px;
                                    height: 64px;
                                    img{
                                        width: 64px;
                                        height: 64px;
                                        border-radius: 50%;
                                    }
                                }
                                .user_info{
                                    width: 200px;
                                    padding:  8px 0;
                                    padding-left: 24px;
                                    display: flex;
                                    flex-wrap: wrap;
                                    align-content: space-between;
                                    .names{
                                        width: 100%;
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #666666;

                                    }
                                    .times{
                                        width: 100%;
                                       
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 12px;
                                        color: #666666;

                                    }
                                }
                                .comment_num{
                                    .num_flex{
                                        display: flex;
                                        align-items: center;
                                        .nums{
                                            img{
                                                width: 21px;
                                                height: 20px;
                                            }
                                        }
                                    }
                                    .comment_text{
                                        font-family: Microsoft YaHei, Microsoft YaHei;
                                        font-weight: 400;
                                        font-size: 14px;
                                        color: #333333;
                                        padding-top: 20px;
                                    }
                                }
                            }
                            .items_bom{
                                // width: 886px;
                                min-height: 78px;
                                background: #F5F5F5;
                                border-radius: 4px 4px 4px 4px;
                                margin-top: 27px;

                                padding:18px 52px 16px 22px ;
                            
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #666666;

                            }
                        }
                        .comment_num_btns{
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            span{
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 16px;
                                color: #8590A6;
                                cursor: pointer;
                            }

                        }
                    }
                }
                .comprehensive_reviews{
                    width: 1000px;
                    min-height: 194px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 20px;
                    padding: 13px 52px 10px 28px;
                    .review_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;

                    }
                    .review_text{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 30px;
                    }
                }
                .announcement_box{
                    width: 1000px;
                    min-height: 271px;
                    background: #FFFFFF;
                    border-radius: 0px 0px 0px 0px;
                    padding: 13px 52px 14px 28px;
                    margin-top: 16px;
                    .announcement_title{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;
                        text-align: center;

                    }
                    .announcement_text{
                        padding-top: 24px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #333333;
                        line-height: 32px;
                    }
                }
            }
            .inof_box_show{
                // width: 100%;
                position: relative;
                height: 1270px;
                overflow: hidden;
                background-color: #FFFFFF;
                .info_pay_btns{
                    width: 100%;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    .info_pay_btns_top{
                        width: 100%;
                        height: 118px;
                        background: linear-gradient( 180deg, rgba(255,255,255,0) 0%, #FFFFFF 100%);
                        border-radius: 0px 0px 0px 0px;
                    }
                    .info_pay_btns_bom{
                        width: 100%;
                        height: 769px;
                        background: #FFFFFF;
                        border-radius: 0px 0px 0px 0px;
                        display: flex;
                        justify-content: center;
                        padding-top: 10px;
                        .btns_pay{
                            width: 134px;
                            height: 36px;
                            background: #377CFD;
                            border-radius: 4px 4px 4px 4px;
                            text-align: center;
                            line-height: 36px;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;
                        }
                    }
                   
                   
                   
                }
            }
        }
    }
}

</style>
<style scoped lang="less">
@media (max-width: 1024px) {
    .case_detial.no-trans {
        max-width: 100%;
        min-width: 0;
        font-size: 14px;
        line-height: 1.6;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        margin: auto;
    }
    .case_detial.no-trans .case_detial_box .top_box {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        padding: 16px 0;
    }
    .case_detial.no-trans .case_detial_box .top_box img {
        width: 14px;
        height: 14px;
        margin-right: 10px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 {
        padding: 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .title_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 24px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .title_flex img {
        margin-left: 10px;
        width: 70px;
        height: 25px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .tage_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .tage_flex .tege_title {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .tage_flex .tege_text {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .tage_info .borders {
        height: 15px;
        margin: 0 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns1 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns1 img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns2 {
        width: 134px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin-left: 16px;
        font-size: 14px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .btns_flex .btns2 img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box {
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        margin-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_flex .const_title {
        width: 100px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_flex .const_text {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .const_const {
        font-size: 14px;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .pl_bq {
        padding: 0 16px;
        font-size: 14px;
        max-width: 100%;
        min-width: 0;
        width: 100%;
        height: 48px;
        border-radius: 0px 0px 0px 0px;
        line-height: 1.6;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .pl_btns {
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .pl_btns .btns1 {
        font-size: 14px;
        margin-bottom: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex .flie_img {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex .flie_img img {
        width: 16px;
        height: 14px;
        margin-right: 10px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .info_1 .const_box .flie_flex .flie_name {
        margin-left: 16px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .case_infos {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 16px 16px 16px 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .case_infos .case_titles {
        font-size: 24px;
        padding-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .case_infos .case_texts {
        font-size: 14px;
        line-height: 30px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_num_box {
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        font-size: 16px;
        margin-top: 16px;
        margin-bottom: 16px;
        min-height: 44px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos {
        padding: 16px 16px 16px 16px;
        border-radius: 0px 0px 0px 0px;
        margin-bottom: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_img {
        width: 64px;
        height: 64px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_img img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_info {
        padding-left: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_info .user_name {
        font-size: 24px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_left .user_info .user_time {
        padding-top: 11px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_user .pl_user_right .user_nums {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_const_box .pl_titles {
        font-size: 16px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_const_box .pl_consts {
        font-size: 14px;
        padding-top: 15px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns1 {
        padding: 8px 16px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns1 img {
        width: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns2 {
        margin-left: 8px;
        width: 36px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns2 img {
        width: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns3 {
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .pl_infos .pl_btns .btns3 img {
        width: 13px;
        margin-right: 4px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section {
        padding: 16px 16px;
        border-radius: 0px 0px 0px 0px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .titles {
        font-size: 18px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns1 {
        padding: 8px 16px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        border-radius: 4px 4px 4px 4px;
        font-size: 14px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns1 img {
        width: 14px;
        height: 14px;
        margin-right: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns2 {
        width: 36px;
        height: auto;
        border-radius: 4px 4px 4px 4px;
        margin-left: 8px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        min-height: 44px;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns2 img {
        width: 14px;
        height: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns3 {
        font-size: 14px;
        margin-left: 16px;
        min-height: 44px;
        height: auto;
        line-height: 1.6;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .title_btns .btns .btns3 img {
        width: 13px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list {
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 3px 3px 3px 3px;
        margin-bottom: 16px;
        padding: 16px 16px 16px 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_imgs {
        width: 64px;
        height: 64px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_imgs img {
        width: 64px;
        height: 64px;
        border-radius: 50%;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_info {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        padding: 8px 0;
        padding-left: 16px;
        flex-wrap: wrap;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_info .names {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .user_info .times {
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .comment_num .num_flex {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .comment_num .num_flex .nums img {
        width: 21px;
        height: 20px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_top .comment_num .comment_text {
        font-size: 14px;
        padding-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .items .items_bom {
        border-radius: 4px 4px 4px 4px;
        margin-top: 16px;
        padding: 16px 16px 16px 16px;
        font-size: 14px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .comment_num_btns {
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comment_section .comment_list .comment_num_btns span {
        font-size: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comprehensive_reviews {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        margin-top: 16px;
        padding: 13px 16px 10px 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comprehensive_reviews .review_title {
        font-size: 18px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .comprehensive_reviews .review_text {
        padding-top: 16px;
        font-size: 14px;
        line-height: 30px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .announcement_box {
        max-width: 100%;
        min-width: 0;
        width: 100%;
        min-height: 0;
        border-radius: 0px 0px 0px 0px;
        padding: 13px 16px 14px 16px;
        margin-top: 16px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .announcement_box .announcement_title {
        font-size: 18px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box .announcement_box .announcement_text {
        padding-top: 16px;
        font-size: 14px;
        line-height: 32px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show {
        min-height: 0;
        height: auto;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show .info_pay_btns .info_pay_btns_top {
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show .info_pay_btns .info_pay_btns_bom {
        min-height: 0;
        height: auto;
        border-radius: 0px 0px 0px 0px;
        flex-wrap: wrap;
        min-width: 0;
        gap: 8px;
        padding-top: 10px;
    }
    .case_detial.no-trans .case_detial_box .detial_flex .inof_box_show .info_pay_btns .info_pay_btns_bom .btns_pay {
        width: 134px;
        height: 36px;
        border-radius: 4px 4px 4px 4px;
        line-height: 36px;
        font-size: 14px;
    }
}
@media (max-width: 1024px) {
    .case_detial.no-trans {
        background: #f4f6f9;
        .case_detial_box {
            .top_box { padding: 8px 16px; gap: 4px; font-size: 13px; line-height: 22px; }
            .top_box .span1 { display: inline-flex; align-items: center; min-width: 44px; min-height: 44px; }
            .top_box > img { display: none; }
            .detial_flex {
                display: flex; flex-direction: column; align-items: stretch; gap: 16px;
                > .inof_box, > .article_sidebar { width: 100%; min-width: 0; }
                .inof_box .info_1 {
                    padding: 20px 16px 12px;
                    .title_flex { display: block; font-size: 22px; line-height: 34px; color: #243247; overflow-wrap: anywhere; }
                    .tage_info { flex-wrap: wrap; gap: 6px 12px; padding-top: 12px; }
                    .tage_info .borders { display: none; }
                    .tage_info .tage_flex { min-width: 0; gap: 0; }
                    .tage_info .tege_title, .tage_info .tege_text { font-size: 13px; line-height: 22px; color: #7b8492; padding: 0; overflow-wrap: anywhere; }
                    > .btns_flex { display: none; }
                    .const_box {
                        margin-top: 16px; padding-top: 18px; border-top: 1px solid #edf0f5;
                        .const_const { padding-bottom: 0; font-size: 16px; line-height: 1.9; color: #344256; overflow-wrap: anywhere; }
                        .const_const /deep/ p { margin: 0 0 16px; }
                        .const_const /deep/ h1, .const_const /deep/ h2, .const_const /deep/ h3 { margin: 22px 0 12px; font-size: 19px; line-height: 30px; }
                        .const_const /deep/ img { display: block; max-width: 100%; height: auto; margin: 16px auto; }
                        .const_const /deep/ ul, .const_const /deep/ ol { padding-left: 24px; }
                        .const_const /deep/ blockquote { margin: 16px 0; padding: 12px; border-left: 3px solid #b7cdf4; background: #f5f8fc; }
                        .pl_bq { height: auto; min-height: 0; margin-top: 12px; padding: 12px; background: #f7f9fc; font-size: 13px; line-height: 22px; color: #7b8492; }
                        .pl_btns { padding-top: 12px; }
                        .pl_btns .btns1 { display: block; min-height: 48px; margin: 0; padding: 14px 0; border-top: 1px solid #edf0f5; font-size: 14px; line-height: 24px; white-space: normal; overflow-wrap: anywhere; }
                    }
                }
                .article_sidebar {
                    padding: 0 16px;
                    /deep/ .case_new.no-trans {
                        width: 100%;
                        .r_top { width: 100%; height: auto; padding: 16px; background: #eaf1ff; }
                        .r_top .titles { font-size: 18px; line-height: 28px; }
                        .r_top .text1 { padding-top: 6px; font-size: 13px; line-height: 22px; color: #687587; }
                        .r_top .nums, .r_top .text2 { display: none; }
                        .r_top .btns_box { padding-top: 12px; }
                        .r_top .btns_box .btns { width: 100%; min-height: 44px; padding: 10px 12px; line-height: 24px; font-size: 14px; }
                        .r_bom {
                            height: 280px; background: #fff;
                            .el-carousel, .el-carousel__container { height: 280px; }
                            .el-carousel .el-carousel__container .banner_box {
                                padding: 54px 16px 16px; background: #fff;
                                .borders_box { width: 88px; height: 88px; }
                                .borders_box .borders1 { display: none; }
                                .borders_box .borders2, .borders_box .borders2 img { width: 88px; height: 88px; }
                                .ls_name { padding-top: 12px; font-size: 18px; line-height: 26px; color: #27364b; }
                                .ls_texts { padding-top: 4px; min-height: 22px; font-size: 13px; line-height: 22px; }
                                .btns_flex { padding-top: 10px; }
                            }
                        }
                        .new_box { width: 100%; margin-top: 16px; padding: 16px; }
                        .new_box .new_titles_btns { align-items: center; }
                        .new_box .new_titles_btns .new_titles { font-size: 18px; line-height: 28px; }
                        .new_box .new_titles_btns .new_btns { display: flex; align-items: center; min-height: 44px; font-size: 13px; }
                        .new_box .nwe_lists .items { padding: 12px 0; margin: 0; min-height: 48px; }
                        .new_box .nwe_lists .items .items_info { min-width: 0; padding-left: 8px; }
                        .new_box .nwe_lists .items .items_titles { white-space: normal; font-size: 14px; line-height: 24px; overflow-wrap: anywhere; }
                        .new_box .nwe_lists .items .tages { padding-top: 6px; font-size: 13px; line-height: 22px; }
                    }
                }
            }
        }
    }
}
</style>
